import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgPhone = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.33 4c.467 0 .91.194 1.275.553.121.111.24.226.375.36l.624.634.967.963c.795.791.795 1.833 0 2.625l-.698.702a15.17 15.17 0 01-.35.336c.247.4 1.223 1.553 2.079 2.384l.296.28c.723.665 1.634 1.404 1.937 1.615l1.044-1.036c.381-.38.832-.581 1.304-.581.474 0 .922.204 1.29.585l1.943 1.942c.38.375.584.827.584 1.302 0 .47-.2.925-.571 1.31-.093.097-.189.194-.296.297l-.344.332a5.874 5.874 0 00-.453.48c-.562.609-1.284.917-2.14.917l-.157-.004-.074-.003c-1.043-.067-1.991-.376-3.164-.93a16.785 16.785 0 01-5.593-4.36c-1.283-1.536-2.15-2.976-2.73-4.536-.358-.96-.535-1.792-.462-2.674a2.695 2.695 0 01.655-1.558l.757-.77.608-.61C6.413 4.194 6.863 4 7.33 4zm0 1.5c-.05 0-.11.02-.17.063l-.062.05-1.217 1.223a1.2 1.2 0 00-.37.78c-.049.59.061 1.193.372 2.027.519 1.393 1.298 2.688 2.473 4.095a15.273 15.273 0 005.085 3.969c.994.47 1.711.699 2.406.771l.19.016.16.006c.442 0 .763-.137.984-.374a6.77 6.77 0 01.43-.468l.548-.532.19-.193c.113-.116.151-.204.151-.269 0-.058-.033-.131-.145-.241l-1.961-1.96c-.095-.099-.16-.128-.211-.128-.059 0-.135.034-.247.146l-1.34 1.33a1 1 0 01-1.278.108l-.461-.323a28.264 28.264 0 01-2.3-1.962c-.877-.851-1.963-2.11-2.311-2.675l-.215-.35a1 1 0 01.17-1.257l.4-.371.217-.21.694-.699c.207-.205.207-.294 0-.5l-.966-.962-.629-.638-.243-.237-.175-.161c-.066-.055-.12-.074-.169-.074z"
      clipRule="evenodd"
    />
  </svg>
));
SvgPhone.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgPhone;
